<template>
    <div class="stepwizard">
        <b-row class="stepwizard-row setup-panel mx-0">
            <b-col v-for="step in steps" :key="step" class="stepwizard-step"> 
              <b-btn :variant="currentStep === step ? 'success' : 'default'" class="btn-circle" :disabled="step != currentStep">
                {{step}}
              </b-btn>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
  name: "StepCounter",
  props: {
    currentStep: Number,
    stepsCount: Number
  },
  computed: {
    steps() {
      let steps = [];
      for (let i = 0; i < this.stepsCount; ++i) {
        steps.push(i + 1);
      }

      return steps;
    }
  }
};
</script>

<style>
.stepwizard-step p {
  margin-top: 0px;
  color: #666;
}
.stepwizard {
  position: relative;
  margin-bottom: 20px;
}
.stepwizard .btn.disabled,
.stepwizard .btn[disabled],
.stepwizard fieldset[disabled] .btn {
  opacity: 1 !important;
  color: black;
}
.stepwizard-row:before {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 100%;
  height: 1px;
  background-color: #ccc;
  z-index: 0;
}
.stepwizard-step {
  text-align: center;
  position: relative;
}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center !important;
  padding: 6px 0 !important;
  font-size: 12px !important;
  line-height: 1.428571429 !important;
  border-radius: 15px !important;
}
</style>
